import React, {Component} from 'react';
import Axios from 'axios';
import Switch from 'react-switch';
import { Link } from 'react-router-dom';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import withRouter from '../Functions/WithRouter';

const closeIcon = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/close-icon.png';
const courseIconBlue = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/course-icon-blue.png';
const deniedIcon = "https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/denied-icon.png";
const profileIconBlue = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/profile-icon-blue.png';
const loadingGIF = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/loading-gif.gif';

class SyncEnrollments extends Component {
    constructor(props) {
      super(props)

      this.state = {
        caseManagerOptions: [],
        stageOptions: ['', 'Enrolled','Completed','Dropped'],

        assignees: [],
        suggestedAssignees: [],
      }

      this.saveChanges = this.saveChanges.bind(this)

      this.retrieveData = this.retrieveData.bind(this)
      this.suggestedItemClicked = this.suggestedItemClicked.bind(this)
      this.addItem = this.addItem.bind(this)
      this.removeItem = this.removeItem.bind(this)

    }

    componentDidMount() {
      document.body.style.backgroundColor = "rgba(178,186,191,0.2)";

      const enrollments = this.props.enrollments
      const syncEnrollments = this.props.syncEnrollments
      const selectedOpportunity = this.props.selectedOpportunity

      const postingId = selectedOpportunity._id
      const selectedProgram = selectedOpportunity.selectedProgram
      if (selectedProgram.id && !selectedProgram._id) {
        selectedProgram['_id'] = selectedProgram.id
        // console.log('assigned id: ', selectedProgram)
      }

      let selectedAssignees = []
      if (enrollments && enrollments.length > 0) {
        for (let i = 1; i <= enrollments.length; i++) {
          if (enrollments[i - 1].stage && enrollments[i - 1].stage !== 'Applied') {
            const enrollment = enrollments[i - 1]
            enrollment['cohort'] = selectedOpportunity.cohort
            selectedAssignees.push(enrollment)
          }
        }
      }

      const emailId = localStorage.getItem('email');
      // const username = localStorage.getItem('username');
      // const cuFirstName = localStorage.getItem('firstName');
      // const cuLastName = localStorage.getItem('lastName');
      // const pictureURL = localStorage.getItem('pictureURL');
      // const orgFocus = localStorage.getItem('orgFocus');
      const orgName = localStorage.getItem('orgName');

      let delegateAdminEmail = emailId

      const activeOrg = localStorage.getItem('activeOrg');

      this.setState({ emailId, delegateAdminEmail, postingId, orgCode: activeOrg, orgName,
        selectedProgram, syncEnrollments, selectedAssignees, selectedOpportunity
      })

      const roleNames = ['Admin']
      Axios.get('/api/org/members', { params: { orgCode: activeOrg, roleNames } })
      .then((response) => {
        if (response.data.success) {
          console.log('Member query worked', response.data);

          if (response.data.members && response.data.members.length > 0) {

            let caseManagerOptions = response.data.members
            if (caseManagerOptions) {
              caseManagerOptions.unshift({})

              this.setState({ caseManagerOptions })

            }
          }

        } else {
          console.log('no members found', response.data.message)
        }
      }).catch((error) => {
          console.log('Members query did not work', error);
      });
    }

    componentDidUpdate(prevProps) {
      console.log('componentDidUpdate called in commonEditEnrollment', this.props.activeOrg, prevProps)

      if (this.props.activeOrg !== prevProps.activeOrg) {
        this.retrieveData()
      }
    }

    retrieveData() {
      console.log('retrieveData called in commonEditEnrollment', this.props)

    }

    formChangeHandler = (event) => {
      console.log('formChangeHandler clicked', event.target.name, event.target.value)

      if (event.target.name === 'programTitle') {
        const programTitle = event.target.value
        this.setState({ programTitle })
        this.searchPrograms(programTitle)
      } else if (event.target.name === 'assigneeName') {
        const assigneeName = event.target.value
        this.setState({ assigneeName })
        this.searchAssignees(assigneeName)
      } else if (event.target.name.startsWith("assignee|")) {

        const index = Number(event.target.name.split("|")[1])
        const fieldName = event.target.name.split("|")[2]

        const selectedAssignees = this.state.selectedAssignees
        selectedAssignees[index][fieldName] = event.target.value
        this.setState({ selectedAssignees })

      } else {
        this.setState({ [event.target.name]: event.target.value })
      }
    }

    searchPrograms(searchString) {
      console.log('searchPrograms called', searchString)

      this.setState({ isSaving: true, isLoadingPrograms: true })

      const orgCode = this.state.orgCode

      const self = this
      function officiallyFilter() {
        console.log('officiallyFilter called')

        Axios.get('/api/programs/search', { params: { searchString, orgCode } })
        .then((response) => {
          console.log('Program search query attempted', searchString, response.data);

            if (response.data.success) {
              console.log('program search query worked')

              const suggestedPrograms = response.data.programs
              self.setState({ suggestedPrograms, isSaving: false, isLoadingPrograms: false });

            } else {
              console.log('program search query did not work', response.data.message)
              const suggestedPrograms = []
              self.setState({ suggestedPrograms, isSaving: false, isLoadingPrograms: false })
            }

        }).catch((error) => {
            console.log('Programs search query did not work for some reason', error);
        });
      }

      const delayFilter = () => {
        console.log('delayFilter called: ')
        clearTimeout(self.state.timerId)
        self.state.timerId = setTimeout(officiallyFilter, 1000)
      }

      delayFilter();
    }

    searchAssignees(assigneeName) {
      console.log('searchAssignees called', assigneeName, this.state.orgCode)

      this.setState({ isSaving: true, isLoadingAssignees: true })

      const orgCode = this.state.orgCode

      const self = this
      function officiallyFilter() {
        console.log('officiallyFilter called')

        Axios.get('/api/assignee/search', { params: { assigneeName, orgCode } })
        .then((response) => {
          console.log('Assignee search query attempted', assigneeName, response.data);

            if (response.data.success) {
              console.log('assignee search query worked')

              const suggestedAssignees = response.data.assignees
              self.setState({ suggestedAssignees, isSaving: false, isLoadingAssignees: false });

            } else {
              console.log('assignee search query did not work', response.data.message)
              const suggestedAssignees = []
              self.setState({ suggestedAssignees, isSaving: false, isLoadingAssignees: false })
            }

        }).catch((error) => {
            console.log('Assignee search query did not work for some reason', error);
        });
      }

      const delayFilter = () => {
        console.log('delayFilter called: ')
        clearTimeout(self.state.timerId)
        self.state.timerId = setTimeout(officiallyFilter, 1000)
      }

      delayFilter();
    }

    addItem(type) {
      console.log('addItem called')

      if (type === 'program') {
        if (this.state.program) {
          let program = this.state.program
          let selectedProgram = this.state.program
          program = null
          let programTitle = ''
          this.setState({ selectedProgram, program, programTitle })
        }
      } else if (type === 'assignee') {
        if (this.state.assignee) {
          let assignee = this.state.assignee
          assignee['stage'] = "Enrolled"
          if (this.state.selectedOpportunity && this.state.selectedOpportunity.cohort) {
            assignee['cohort'] = this.state.selectedOpportunity.cohort
          }

          let selectedAssignees = this.state.selectedAssignees
          if (selectedAssignees) {
            selectedAssignees.push(assignee)
          } else {
            selectedAssignees = [assignee]
          }
          assignee = null
          let assigneeName = ''
          let suggestedAssignees = []
          this.setState({ selectedAssignees, assignee, assigneeName, suggestedAssignees })
        }
      }
    }

    removeItem(type, index) {
      console.log('removeItem called', type, index)

      if (type === 'assignee') {
        let selectedAssignees = this.state.selectedAssignees
        selectedAssignees.splice(index, 1)
        this.setState({selectedAssignees })
      }
    }

    suggestedItemClicked(type, value) {
      console.log('suggestedItemClicked called ', type, value)

      if (type === 'program') {
        const suggestedPrograms = []
        const programTitle = value.title

        this.setState({ suggestedPrograms, program: value, programTitle })
      } else if (type === 'assignee') {
        const suggestedAssignees = []
        const assigneeName = value.firstName + ' ' + value.lastName

        this.setState({ suggestedAssignees, assignee: value, assigneeName })
      }
    }

    saveChanges() {
      console.log('saveChanges called')

      this.setState({ isSaving: true, errorMessage: null, successMessage: null })

      if (!this.state.selectedProgram) {
        return this.setState({ errorMessage: 'please add a program', isSaving: false })
      } else if (!this.state.selectedAssignees) {
        return this.setState({ errorMessage: 'please add assignees', isSaving: false })
      } else {

        let selectedAssignees = this.state.selectedAssignees

        for (let i = 1; i <= this.state.selectedAssignees.length; i++) {
          if (!this.state.selectedAssignees[i - 1].stage) {
            return this.setState({ errorMessage: 'please add a stage for enrollee #' + i.toString(), isSaving: false })
          } else {
            if (this.state.selectedAssignees[i - 1].caseManagerName) {
              for (let j = 1; j <= this.state.caseManagerOptions.length; j++) {
                const item = this.state.caseManagerOptions[j - 1]
                if (item.firstName + " " + item.lastName === this.state.selectedAssignees[i - 1].caseManagerName) {
                  let caseManager = { firstName: item.firstName, lastName: item.lastName, email: item.email, username: item.username }
                  selectedAssignees[i - 1]['caseManager'] = caseManager
                }
              }
            }
          }
        }

        const selectedProgram = this.state.selectedProgram
        const delegateAdminEmail = this.state.delegateAdminEmail
        const enrollmentType = "Program"
        const postingId = this.state.postingId

        const orgCode = this.state.orgCode
        const orgName = this.state.orgName

        const enrollmentObject = {
          selectedAssignees, selectedProgram, delegateAdminEmail, enrollmentType, postingId,
          orgCode, orgName
        }

        console.log('show enrollmentObject: ', enrollmentObject)

        Axios.post('/api/enrollments/bulk', enrollmentObject)
        .then((response) => {

          if (response.data.success) {
            console.log('Enrollment save worked', response.data);

            this.setState({ successMessage: response.data.message, isSaving: false })

            // if (this.props.passData) {
            //   this.props.passData('enrollment',enrollmentObject)
            // }
            //
            // if (this.props.closeModal) {
            //   this.props.closeModal()
            // }

          } else {
            console.error('there was an error saving the enrollment');
            this.setState({ errorMessage: response.data.message, isSaving: false})
          }
        }).catch((error) => {
            console.log('The enrollment save did not work', error);
            this.setState({ errorMessage: error.toString(), isSaving: false })
        });
      }
    }

    switchPreferences(change, shortname) {
      console.log('switchPreferences called', change, shortname)

      this.setState({ [shortname]: change })

    }

    render() {

      return (
          <div>
            <div className="spacer" />
            <div className="row-10">
              <div>
                <div className="calc-column-offset-20">
                  <p className="heading-text-2">Sync Enrollments</p>
                </div>
                <div className="fixed-column-20">
                  <button type="button" className="background-button full-width right-text" onClick={() => this.props.closeModal()}>
                    <img src={closeIcon} alt="GC" className="image-auto-15 pin-right" data-tooltip-id="tooltip-placeholder-id" data-tooltip-content="Close modal"/>
                  </button>
                </div>
                <div className="clear" />
              </div>

              <div className="top-margin">
                <p>All applicants with advanced stages (e.g., enrolled, dropped, completed) are tagged below for auto-enrollment into the program. If an enrollment for the user with this program already exists, this will skip that enrollment.</p>
              </div>

              <ReactTooltip id="tooltip-placeholder-id" />
            </div>
            {/* Select program or course
            <div className="row-10">
              <div className="container-left">
                <p className="profile-label"> {this.state.orgName}'s list <label className="error-color">*</label></p>
                <select name={"addCertificateMethod"} value={this.state.addCertificateMethod} onChange={this.formChangeHandler} className="dropdown">
                  {this.state.addCertificateMethodOptions.map(value =>
                    <option key={value} value={value}>{value}</option>
                  )}
                </select>
              </div>
              <div className="container-right">
              </div>
              <div className="clear" />
            </div>
            */}

            {/*<p>program or course, case manager, wioa eligible, enrollment status/stage</p>*/}

            <div className="row-20">
              <div className="bottom-margin-15">
                <label className="profile-label">Selected Program</label>

                <div>
                  <div className="calc-column-offset-100 right-padding">
                    <input type="text" className="text-field" placeholder="Search by program name..." name="programTitle" value={this.state.programTitle} onChange={this.formChangeHandler}></input>
                  </div>
                  <div className="fixed-column-100">
                    <button className="btn btn-squarish" onClick={() => this.addItem('program')}>Add</button>
                  </div>
                  <div className="clear" />
                </div>

                <div className="clear" />
                <div className="spacer" />

                {(this.state.isLoadingPrograms) ? (
                  <div className="flex-container flex-center full-space">
                    <div>
                      <div className="super-spacer" />

                      <img src={loadingGIF} alt="GC" className="image-auto-80 center-horizontally"/>
                      <div className="spacer" /><div className="spacer" /><div className="spacer" />
                      <p className="center-text cta-color bold-text">Searching programs...</p>

                    </div>
                  </div>
                ) : (
                  <div>
                    {(this.state.suggestedPrograms && this.state.suggestedPrograms.length > 0) && (
                      <div>
                        <div className="spacer" />
                        {this.state.suggestedPrograms.map(value =>
                          <div key={value._id} className="row-5">
                            <button className="background-button" onClick={() => this.suggestedItemClicked('program',value)}>
                              <div>
                                <div className="float-left right-padding">
                                  <img src={courseIconBlue} alt="Compass employer icon icon" className="image-auto-22" />
                                </div>
                                <div className="float-left">
                                  <p className="cta-color">{value.title}</p>
                                </div>
                              </div>
                            </button>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                )}

                {(this.state.selectedProgram) && (
                  <div key={"selectedProgram"} className="float-left">
                    <div className="close-button-container-1">
                      <button className="background-button" onClick={() => this.setState({ selectedProgram: null })}>
                        <img src={deniedIcon} alt="Compass target icon" className="image-auto-20" />
                      </button>
                    </div>
                    <div className="float-left row-5 right-padding">
                      <div className="tag-container-5">
                        <p className="description-text-2">{this.state.selectedProgram.title}</p>
                      </div>
                    </div>
                  </div>
                )}

                <div className="clear" />
              </div>

              <div className="row-15">
                <label className="profile-label">Selected Applicants (or Members) to be Enrolled</label>

                <div>
                  <div className="calc-column-offset-100 right-padding">
                    <input type="text" className="text-field" placeholder="Search a name or email..." name="assigneeName" value={this.state.assigneeName} onChange={this.formChangeHandler}></input>
                  </div>
                  <div className="fixed-column-100">
                    <button className="btn btn-squarish" onClick={() => this.addItem('assignee')}>Add</button>
                  </div>
                  <div className="clear" />
                </div>

                <div className="clear" />
                <div className="spacer" />

                {(this.state.isLoadingAssignees) ? (
                  <div className="flex-container flex-center full-space">
                    <div>
                      <div className="super-spacer" />

                      <img src={loadingGIF} alt="GC" className="image-auto-80 center-horizontally"/>
                      <div className="spacer" /><div className="spacer" /><div className="spacer" />
                      <p className="center-text cta-color bold-text">Searching members...</p>

                    </div>
                  </div>
                ) : (
                  <div>
                    {(this.state.suggestedAssignees && this.state.suggestedAssignees.length > 0) && (
                      <div>
                        <div className="spacer" />
                        {this.state.suggestedAssignees.map(value =>
                          <div key={value._id} className="row-5">
                            <button className="background-button" onClick={() => this.suggestedItemClicked('assignee',value)}>
                              <div>
                                <div className="float-left right-padding">
                                  <img src={profileIconBlue} alt="Compass employer icon icon" className="image-auto-22" />
                                </div>
                                <div className="float-left">
                                  <p className="cta-color">{value.firstName} {value.lastName} ({value.email})</p>
                                </div>
                              </div>
                            </button>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                )}

                {(this.state.selectedAssignees && this.state.selectedAssignees.length > 0) && (
                  <div>
                    {/*
                    {this.state.selectedAssignees.map((item, optionIndex) =>
                      <div key={(item) ? "assignee" + item.createdAt : "assignee "} className="float-left bottom-margin right-margin">
                        <div className="close-button-container-1">
                          <button className="background-button" onClick={() =>  this.removeItem('assignee',optionIndex)}>
                            <img src={deniedIcon} alt="Compass target icon" className="image-auto-20" />
                          </button>
                        </div>
                        <div className="float-left row-5 right-padding">
                          <div className="tag-container-5">
                            <p className="description-text-2"></p>
                            <Link className="description-text-2" to={"/organizations/" + this.state.orgCode + "/members/" + item.username} target="_blank" rel="noopener noreferrer">{item.firstName} {item.lastName} ({item.email})</Link>
                          </div>
                        </div>
                      </div>
                    )}*/}

                    <div className=" white-background table-container standard-border medium-shadow top-margin-20">
                      <table className={"default-table"}>
                        <colgroup>
                          <col style={{ width: '40px' }} />
                          <col />
                          <col />
                          <col />
                          <col />
                          <col />
                        </colgroup>
                        <thead>
                          <tr>
                            <th> </th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Stage</th>
                            <th>Cohort</th>
                            <th>Case Manager</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.selectedAssignees.map((item, optionIndex) =>
                            <tr key={(item) ? "assignee" + item.createdAt : "assignee "}>
                              <td>
                                <button className="background-button" onClick={() =>  this.removeItem('assignee',optionIndex)}>
                                  <img src={deniedIcon} alt="GC" className="image-auto-20" />
                                </button>
                              </td>
                              <td>{item.firstName} {item.lastName}</td>
                              <td>{item.email}</td>
                              <td>
                                <select name={"assignee|" + optionIndex + "|stage"} value={item.stage} onChange={this.formChangeHandler} className="dropdown width-110">
                                  {this.state.stageOptions.map(value =>
                                    <option key={value} value={value}>{value}</option>
                                  )}
                                </select>
                              </td>
                              <td>
                                <input type="number" className="number-field width-50" placeholder="0" name={"assignee|" + optionIndex + "|cohort"} value={item.cohort} onChange={this.formChangeHandler}></input>
                              </td>
                              <td>
                                <select name={"assignee|" + optionIndex + "|caseManagerName"} value={item.caseManagerName} onChange={this.formChangeHandler} className="dropdown width-170">
                                  {this.state.caseManagerOptions.map(value =>
                                    <option key={(value.username) ? value.username : "cmo"} value={(value.username) ? value.firstName + " " + value.lastName : ""}>{(value.username) ? value.firstName + " " + value.lastName : ""}</option>
                                  )}
                                </select>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>

                  </div>
                )}

                <div className="clear" />
              </div>
            </div>

            <div className="top-margin-20">
              {(this.state.errorMessage && this.state.errorMessage !== '') && <p className="error-color description-text-2 row-5">{this.state.errorMessage}</p>}
              {(this.state.successMessage && this.state.successMessage !== '') && <p className="cta-color description-text-2 row-5">{this.state.successMessage}</p>}

              <div className="top-margin">
                <button className="btn btn-primary right-margin" disabled={this.state.isSaving} onClick={() => this.saveChanges()}>Bulk-Add Enrollments</button>
              </div>
            </div>

          </div>

      )
    }
}

export default withRouter(SyncEnrollments);
